
// import React, { useState } from 'react';
// import axios from 'axios';
// import Header from './Header';
// import { Link, useNavigate } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Footer2 from './Footer2';
// import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';

// const Login = () => {
//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [showPassword, setShowPassword] = useState(false);
//     const navigate = useNavigate();

//     const handleLogin = async () => {

//         // ✅ Check 1: Empty fields
//         if (!email.trim()) {
//             toast.error("Please enter your email");
//             return;
//         }

//         // ✅ Check 2: Email format
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(email.trim())) {
//             toast.error("Please enter a valid email address");
//             return;
//         }

//         // ✅ Check 3: Real email domain only
//         const emailDomain = email.split('@')[1]?.toLowerCase();
//         const validDomains = [
//             'gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com',
//             'icloud.com', 'protonmail.com', 'rediffmail.com', 'live.com',
//             'ymail.com', 'zoho.com', 'aol.com', 'msn.com'
//         ];
//         if (!validDomains.includes(emailDomain)) {
//             toast.error("Please use a valid email (Gmail, Yahoo, Outlook etc.)");
//             return;
//         }

//         if (!password.trim()) {
//             toast.error("Please enter your password");
//             return;
//         }

//         try {
//             const response = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/userlogin`, {
//                 Email: email.trim(),
//                 Password: password.trim()
//             });

//             const data = response.data;

//             // ✅ Backend message — "Login success" (exact match)
//             if (data.message === "Login success") {
//                 localStorage.setItem("user", JSON.stringify(data.user));
//                 localStorage.setItem("token", data.token);
//                 toast.success("Successfully logged in!");
//                 // console.log("Login Success:", data);
//                 setTimeout(() => {
//                     navigate('/home');
//                 }, 1500);
//             } else {
//                 toast.error(data.message || "Login failed.");
//             }

//         } catch (error) {
//             // console.error("Login Failed:", error);

//             // ✅ 401 error — backend message
//             if (error.response?.data?.message) {
//                 const msg = error.response.data.message;
//                 if (msg === "User not found") {
//                     toast.error("No account found with this email. Please register first.");
//                 } else if (msg === "Wrong password") {
//                     toast.error("Incorrect password. Please try again.");
//                 } else {
//                     toast.error(msg);
//                 }
//             } else {
//                 toast.error("Unable to connect to server.");
//             }
//         }
//     };

//     return (
//         <>
//             <Header />
//             <ToastContainer />
// {/* Hide browser default eye icon */}
//             <style>{`
//                 input[type="password"]::-ms-reveal,
//                 input[type="password"]::-ms-clear,
//                 input::-webkit-credentials-auto-fill-button,
//                 input::-webkit-textfield-decoration-container {
//                     display: none !important;
//                 }
//             `}</style>
//             <body>
//                 <div id="login" class="tab-content active">
//                     <div class="login-main">
//                         <div class="container">
//                             <div class="login-inner-main">
//                                 <div class="login-child">
//                                     <h2 class="login-title">Login</h2>
//                                     <div class="login-inner-child">
//                                         <label for="email">E-MAIL</label>
//                                         <input
//                                             type="email"
//                                             id="email"
//                                             class="login-input"
//                                             value={email}
//                                             onChange={(e) => setEmail(e.target.value)}
//                                         />

//                                         <div class="password-section">
//                                             <label for="password">PASSWORD</label>
//                                         </div>
//                                         <div className="password-input-wrapper" style={{ position: 'relative' }}>
//                                             <input
//                                                 type={showPassword ? "text" : "password"}
//                                                 class="login-input"
//                                                 value={password}
//                                                 onChange={(e) => setPassword(e.target.value)}
//                                             />
//                                             <span
//                                                 onClick={() => setShowPassword(!showPassword)}
//                                                 style={{
//                                                     position: 'absolute',
//                                                     right: '10px',
//                                                     top: '15px',
//                                                     cursor: 'pointer',
//                                                     fontSize: '18px',
//                                                     color: '#5a5a5a'
//                                                 }}
//                                             >
//                                                 {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
//                                             </span>
//                                         </div>

//                                         <button class="login-button" onClick={handleLogin}>SIGN IN</button>
//                                         <p className="create-account"><Link to='/Creteaccount' className="create-account"> Create Account </Link></p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </body>

//             <Footer2 />
//         </>
//     );
// };

// export default Login;

import React, { useState } from 'react';
import axios from 'axios';
import Header from './Header';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useCart } from './CartContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer2 from './Footer2';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const { fetchCartData } = useCart();

    const handleLogin = async () => {

        // Check 1: Empty email
        if (!email.trim()) {
            toast.error("Please enter your email");
            return;
        }

        // Check 2: Email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
            toast.error("Please enter a valid email address");
            return;
        }

        // Check 3: Real email domain only
        const emailDomain = email.split('@')[1]?.toLowerCase();
        const validDomains = [
            'gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com',
            'icloud.com', 'protonmail.com', 'rediffmail.com', 'live.com',
            'ymail.com', 'zoho.com', 'aol.com', 'msn.com'
        ];
        if (!validDomains.includes(emailDomain)) {
            toast.error("Please use a valid email (Gmail, Yahoo, Outlook etc.)");
            return;
        }

        // Check 4: Empty password
        if (!password.trim()) {
            toast.error("Please enter your password");
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/userlogin`, {
                Email: email.trim(),
                Password: password.trim()
            });

            const data = response.data;

            if (data.message === "Login success") {
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("token", data.token);

                // Guest cart merge
                const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                for (const item of guestCart) {
                    await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/addtocart`, {
                        Product_ID: item.Product_Id,
                        Category_ID: item.Category_Id,
                        SubCategory_ID: item.SubCategory_Id,
                        Quantity: item.Quantity,
                        Customer_ID: data.user.UserID,
                    }).catch(() => {});
                }
                localStorage.removeItem('guestCart');

                await fetchCartData();

                toast.success("Successfully logged in!");
                setTimeout(() => {
                    const redirectTo = location.state?.redirectTo || '/home';
                    navigate(redirectTo);
                }, 1500);

            } else {
                toast.error(data.message || "Login failed.");
            }

        } catch (error) {
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (msg === "User not found") {
                    toast.error("No account found with this email. Please register first.");
                } else if (msg === "Wrong password") {
                    toast.error("Incorrect password. Please try again.");
                } else {
                    toast.error(msg);
                }
            } else {
                toast.error("Unable to connect to server.");
            }
        }
    };

    return (
        <>
            <Header />
            <ToastContainer draggable={false} />

            {/* Hide browser default eye icon */}
            <style>{`
                input[type="password"]::-ms-reveal,
                input[type="password"]::-ms-clear,
                input::-webkit-credentials-auto-fill-button,
                input::-webkit-textfield-decoration-container {
                    display: none !important;
                }
            `}</style>

            <div id="login" className="tab-content active">
                <div className="login-main">
                    <div className="container">
                        <div className="login-inner-main">
                            <div className="login-child">
                                <h2 className="login-title">Login</h2>

                                <div className="login-inner-child">
                                    {/* form tag — fixes "Password field not in form" warning */}
                                    <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>

                                        <label htmlFor="email">E-MAIL</label>
                                        <input
                                            type="email"
                                            id="email"
                                            className="login-input"
                                            autoComplete="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />

                                        <div className="password-section">
                                            <label htmlFor="password">PASSWORD</label>
                                        </div>

                                        <div className="password-input-wrapper" style={{ position: 'relative' }}>
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                id="password"
                                                className="login-input"
                                                autoComplete="current-password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <span
                                                onClick={() => setShowPassword(!showPassword)}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '15px',
                                                    cursor: 'pointer',
                                                    fontSize: '18px',
                                                    color: '#5a5a5a'
                                                }}
                                            >
                                                {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                                            </span>
                                        </div>

                                        <button type="submit" className="login-button">SIGN IN</button>
                                        <p className="create-account">
                                            <Link to='/Creteaccount' className="create-account">Create Account</Link>
                                        </p>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer2 />
        </>
    );
};

export default Login;